import React from "react";
import { FaInstagramSquare } from "react-icons/fa";
import {
  FiArrowUpRight,
  FiCheck,
  FiClock,
  FiMail,
  FiMapPin,
  FiPhoneCall,
} from "react-icons/fi";
import { ImFacebook, ImLinkedin2, ImYoutube2 } from "react-icons/im";
import ContactForm from "./ContactForm";

const contactDetails = [
  {
    icon: FiMail,
    label: "Email us",
    value: "info@abscod.com",
    href: "mailto:info@abscod.com",
  },
  {
    icon: FiPhoneCall,
    label: "Call us",
    value: "+91 86300 62102",
    href: "tel:+918630062102",
  },
];

const socialLinks = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/abscod-informatics/?original_referer=",
    icon: ImLinkedin2,
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/abscod.informatics/",
    icon: ImFacebook,
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@abscodinformatics",
    icon: ImYoutube2,
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/abscod.informatics/",
    icon: FaInstagramSquare,
  },
];

const ContactLandingPage = () => {
  return (
    <section className="contact-hero-scroll relative isolate overflow-x-hidden overflow-y-auto bg-[#070a10] px-5 pb-16 pt-28 text-white md:px-8 md:pb-20 md:pt-32 lg:px-12 lg:pb-10 lg:pt-28 xl:pb-12 xl:pt-32">
      <div className="absolute inset-0 -z-30 bg-[radial-gradient(circle_at_9%_18%,rgba(100,60,144,0.42),transparent_28%),radial-gradient(circle_at_92%_12%,rgba(255,219,22,0.14),transparent_25%),radial-gradient(circle_at_70%_88%,rgba(35,155,230,0.17),transparent_30%)]" />
      <div className="absolute inset-0 -z-20 opacity-[0.07] [background-image:linear-gradient(rgba(255,255,255,0.45)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.45)_1px,transparent_1px)] [background-size:72px_72px] [mask-image:linear-gradient(to_bottom,black,transparent_92%)]" />
      <div className="absolute -left-28 top-36 -z-10 h-72 w-72 rounded-full border border-white/10" />
      <div className="absolute -left-12 top-52 -z-10 h-36 w-36 rounded-full border border-[#FFDB16]/20" />
      <div className="absolute left-[7%] top-64 -z-10 h-4 w-4 rounded-full bg-[#FFDB16] shadow-[0_0_45px_12px_rgba(255,219,22,0.28)]" />
      <div className="absolute right-[8%] top-32 -z-10 h-28 w-28 rotate-12 rounded-[32px] border border-white/10 bg-white/[0.025]" />

      <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-[0.92fr_1.08fr] lg:gap-12 xl:gap-20">
        <div className="relative">
          <div className="mb-5 inline-flex items-center gap-3 rounded-full border border-white/10 bg-white/[0.06] px-4 py-2 backdrop-blur-xl lg:mb-4 lg:px-3 lg:py-1.5">
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
              <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-400" />
            </span>
            <span className="text-sm font-bold tracking-wide text-slate-200">
              We&rsquo;re ready when you are
            </span>
          </div>

          <h1 className="max-w-2xl font-heading text-[2.75rem] font-extrabold leading-[1.03] tracking-[-0.045em] text-white sm:text-6xl lg:text-[3.65rem] xl:text-[4.1rem]">
            Let&rsquo;s build something
            <span className="relative mt-1 block w-fit text-[#FFDB16]">
              remarkable.
              <span className="absolute -bottom-2 left-0 h-1 w-20 rounded-full bg-[#FFDB16] sm:w-28" />
            </span>
          </h1>

          <p className="mt-7 max-w-xl text-lg leading-8 text-slate-300 md:text-xl lg:mt-5 lg:text-lg lg:leading-7">
            Have an idea, a challenge, or a product ready for its next chapter?
            Tell us where you want to go&mdash;we&rsquo;ll help map the way forward.
          </p>

          <div className="mt-5 flex flex-wrap gap-x-6 gap-y-3 text-sm font-semibold text-slate-300 lg:mt-4">
            <span className="flex items-center gap-2">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#FFDB16]/15 text-[#FFDB16]">
                <FiClock className="h-3.5 w-3.5" />
              </span>
              Reply within one business day
            </span>
            <span className="flex items-center gap-2">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#FFDB16]/15 text-[#FFDB16]">
                <FiCheck className="h-3.5 w-3.5" />
              </span>
              No-obligation conversation
            </span>
          </div>

          <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:mt-6">
            {contactDetails.map(({ icon: Icon, label, value, href }) => (
              <a
                key={label}
                href={href}
                className="group flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.055] p-4 backdrop-blur-xl transition duration-300 hover:-translate-y-1 hover:border-[#FFDB16]/40 hover:bg-white/[0.1] hover:shadow-[0_18px_45px_rgba(0,0,0,0.22)] lg:p-3.5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#FFDB16] text-slate-950 shadow-[0_10px_30px_rgba(255,219,22,0.18)]">
                  <Icon className="h-5 w-5" />
                </span>
                <span className="min-w-0">
                  <span className="block text-xs font-bold uppercase tracking-wider text-slate-400">
                    {label}
                  </span>
                  <span className="mt-1 block truncate font-semibold text-white">
                    {value}
                  </span>
                </span>
                <FiArrowUpRight className="ml-auto h-5 w-5 shrink-0 text-slate-500 transition duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#FFDB16]" />
              </a>
            ))}
          </div>

          <address className="mt-3 flex items-start gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-4 not-italic backdrop-blur-xl lg:p-3.5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#643c90] text-white shadow-[0_10px_30px_rgba(100,60,144,0.3)]">
              <FiMapPin className="h-5 w-5" />
            </span>
            <div>
              <p className="text-xs font-bold uppercase tracking-wider text-slate-400">
                Visit our office
              </p>
              <p className="mt-1 max-w-md font-semibold leading-6 text-white">
                Plot 44, Sector 5, Rajendra Nagar, Ghaziabad, UP 201005, India
              </p>
            </div>
          </address>

          <div className="mt-5 flex flex-wrap items-center gap-2.5 lg:mt-4">
            <span className="mr-2 text-xs font-bold uppercase tracking-[0.14em] text-slate-500">
              Follow along
            </span>
            {socialLinks.map(({ label, href, icon: Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/[0.05] text-slate-300 transition duration-300 hover:-translate-y-1 hover:border-[#FFDB16] hover:bg-[#FFDB16] hover:text-slate-950 lg:h-9 lg:w-9"
              >
                <Icon className="h-5 w-5" />
              </a>
            ))}
          </div>
        </div>

        <div className="relative lg:pl-2">
          <div className="absolute -inset-5 -z-10 rounded-[40px] bg-gradient-to-br from-[#FFDB16]/20 via-transparent to-[#643c90]/35 blur-2xl" />
          <div className="absolute -right-3 -top-3 z-10 hidden items-center gap-2 rounded-full border border-white/70 bg-white px-4 py-2 text-xs font-extrabold uppercase tracking-[0.11em] text-slate-900 shadow-xl sm:flex">
            <span className="h-2 w-2 rounded-full bg-emerald-500" />
            Taking new projects
          </div>
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default ContactLandingPage;
